import styled from "styled-components";
import { LoadingContainer } from "../../destination-account/screens/styles";

export const HenryIntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const HenryAvatorDiv = styled.div<{ $marginBottom?: number }>`
  z-index: 1;
  display: block;
  ${(props) => props.$marginBottom && `margin-bottom: ${props.$marginBottom}px;`}
`;

export const HenryIntroCard = styled.div`
  display: flex;
  background: white;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -28px;
  z-index: 0;
  padding: 32px 16px;
  border-radius: 6px;
  width: 100%;
`;

export const OptionTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-top: 40px;
`;

export const HenryLoadingContainer = styled(LoadingContainer)<{ $maxWidth?: string }>`
  max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : "227px")};
  margin-left: auto;
  margin-right: auto;
`;

export const HenryLottieContainer = styled.div`
  margin-top: -32px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: cetner;
`;

export const FirstOptionContainer = styled.div`
  margin-top: 24px;
`;

export const SecondOptionContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
